import { StyleSheet } from 'react-native';
import { FONTS } from '../../constants';
import { STYLE_VARS } from '../../constants/style-vars';

export const collapseStyled = StyleSheet.create({
  header: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingVertical: 15,
    borderWidth: 1,
    justifyContent: 'space-between',
    borderColor: STYLE_VARS.kccBorderGreen,
    alignItems: 'center',
  },
  headerLine: {
    width: 20,
    height: 1,
    backgroundColor: STYLE_VARS.kccBgGreen,
  },
  headerTitle: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 18,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
  },
});
